import React from 'react';
import { SelectedStand } from '../types/stand.types';
interface ConfirmedStandsProps {
  confirmedStands: SelectedStand[];
  onRemoveStand?: (standId: string) => void;
  readOnly?: boolean;
}
const ConfirmedStands: React.FC<ConfirmedStandsProps> = ({ confirmedStands, onRemoveStand, readOnly = true }) => {
  return (
    <div className="confirmed-stands">
      <h3 className="confirmed-stands-title">Stands Confirmados</h3>
      {confirmedStands.length === 0 ? (
        <div className="empty-selection">
          <p>Aquí aparecerán sus espacios confirmados</p>
        </div>
      ) : (
        <div className="stands-list">
          {confirmedStands.map(stand => (
            <div key={stand.id} className="confirmed-stand">
              <div className="confirmed-stand-info">
                <span className="confirmed-stand-number">{stand.name}</span>
                {stand.size && <span className="confirmed-stand-size">{stand.size}</span>}
              </div>
              {!readOnly && onRemoveStand && (
                <button 
                  className="remove-stand"
                  onClick={() => onRemoveStand(stand.id)}
                >
                  ✕
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default ConfirmedStands;
